<input
    type="text"
    class="form-control full-width"
    *ngIf="enableFilter"
    [(ngModel)]="query"
    (keyup)="filter()"
    placeholder="Filter"
/>
<div class="row display-flex flex-wrap" style="padding-top: 15px">
    <div
        *ngFor="let row of getData()"
        [ngClass]="
            show4Columns
                ? 'col-12 col-lg-3 col-sm-6 text-center'
                : 'col-12 col-sm-6 col-lg-4 text-center'
        "
    >
        <span *ngFor="let item of items">
            <a
                [routerLink]="buildUrl(url, row['url'], row[item.id])"
               >
                <div class="card">
                    <div class="card-header bg-primary">
                        <h3 class="card-title mb-0">{{ row[item.header] }}</h3>
                    </div>
                    <div class="card-body">
                        <h3 class="mt-4">{{ row[item.name] }}</h3>
                        <small>{{ row[item.description] }}</small>
                    </div>
                </div>
            </a>
        </span>
    </div>
</div>
